import { render, staticRenderFns } from "./SettingsRequireFullTeams.vue?vue&type=template&id=19bc4f58&"
import script from "./SettingsRequireFullTeams.vue?vue&type=script&lang=js&"
export * from "./SettingsRequireFullTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports